module.exports = __webpack_public_path__ + "img/dangyuan_icon.3f5f2107.png";